@if (feedBackStage) {
  <div class="inner-feedback-section horizontal-line">
    <div class="feedback-text">
      AI can make mistakes. Check important information.
    </div>
    <div class="feedback-icons horizontal-line">
      <div class="like" (click)="likeFeedback()" (keydown)="likeFeedback()">
        @if (!isLikeSelected) {
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Like</title>
            <g clip-path="url(#clip0_1261_17250)">
              <path
                d="M5.25 8.25029V14.2503C5.25 14.4492 5.17098 14.64 5.03033 14.7806C4.88968 14.9213 4.69891 15.0003 4.5 15.0003H3C2.80109 15.0003 2.61032 14.9213 2.46967 14.7806C2.32902 14.64 2.25 14.4492 2.25 14.2503V9.00029C2.25 8.80138 2.32902 8.61062 2.46967 8.46996C2.61032 8.32931 2.80109 8.25029 3 8.25029H5.25ZM5.25 8.25029C6.04565 8.25029 6.80871 7.93422 7.37132 7.37162C7.93393 6.80901 8.25 6.04594 8.25 5.25029V4.50029C8.25 4.10247 8.40804 3.72094 8.68934 3.43964C8.97064 3.15833 9.35218 3.00029 9.75 3.00029C10.1478 3.00029 10.5294 3.15833 10.8107 3.43964C11.092 3.72094 11.25 4.10247 11.25 4.50029V8.25029H13.5C13.8978 8.25029 14.2794 8.40833 14.5607 8.68964C14.842 8.97094 15 9.35247 15 9.75029L14.25 13.5003C14.1421 13.9604 13.9375 14.3555 13.667 14.626C13.3964 14.8966 13.0746 15.0279 12.75 15.0003H7.5C6.90326 15.0003 6.33097 14.7632 5.90901 14.3413C5.48705 13.9193 5.25 13.347 5.25 12.7503"
                stroke="#5F626B"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_1261_17250">
                <rect
                  width="18"
                  height="18"
                  fill="white"
                  transform="matrix(1 0 0 -1 0 18)"
                />
              </clipPath>
            </defs>
          </svg>
        }

        @if (isLikeSelected) {
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_like_main)">
              <path
                d="M9.75 2.25C10.3239 2.24997 10.8761 2.46924 11.2937 2.86296C11.7113 3.25668 11.9626 3.79508 11.9963 4.368L12 4.5V7.5H13.5C14.0513 7.49991 14.5835 7.70226 14.9955 8.06864C15.4075 8.43502 15.6707 8.93992 15.735 9.4875L15.7463 9.618L15.75 9.75L15.735 9.897L14.9805 13.671C14.6948 14.8905 13.854 15.768 12.873 15.756L12.75 15.75H6.75C6.5663 15.75 6.389 15.6825 6.25172 15.5605C6.11444 15.4384 6.02674 15.2702 6.00525 15.0878L6 15L6.00075 7.848C6.00089 7.71648 6.0356 7.5873 6.10142 7.47344C6.16724 7.35957 6.26185 7.26501 6.37575 7.19925C6.69557 7.01454 6.96496 6.7539 7.16013 6.44035C7.35529 6.1268 7.47022 5.77001 7.49475 5.4015L7.5 5.25V4.5C7.5 3.90326 7.73705 3.33097 8.15901 2.90901C8.58097 2.48705 9.15326 2.25 9.75 2.25Z"
                fill="#088E6D"
              />
              <path
                d="M3.75 7.5C3.9337 7.50002 4.111 7.56747 4.24828 7.68954C4.38556 7.81161 4.47326 7.97981 4.49475 8.16225L4.5 8.25V15C4.49998 15.1837 4.43253 15.361 4.31046 15.4983C4.18839 15.6356 4.02019 15.7233 3.83775 15.7448L3.75 15.75H3C2.62157 15.7501 2.25708 15.6072 1.97959 15.3499C1.7021 15.0926 1.53213 14.7399 1.50375 14.3625L1.5 14.25V9C1.49988 8.62157 1.6428 8.25708 1.90012 7.97959C2.15744 7.7021 2.51013 7.53213 2.8875 7.50375L3 7.5H3.75Z"
                fill="#088E6D"
              />
            </g>
            <defs>
              <clipPath id="clip0_like_main">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
        }
      </div>
      <div
        class="dislike"
        (click)="openDislikePopup()"
        (keydown)="openDislikePopup()"
      >
        @if (!isDislikeSelected) {
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_dislike_main)">
              <path
                d="M6 9.75361V3.75361C6 3.5547 5.92098 3.36393 5.78033 3.22328C5.63968 3.08263 5.44891 3.00361 5.25 3.00361H3.75C3.55109 3.00361 3.36032 3.08263 3.21967 3.22328C3.07902 3.36393 3 3.5547 3 3.75361V9.00361C3 9.20252 3.07902 9.39329 3.21967 9.53394C3.36032 9.67459 3.55109 9.75361 3.75 9.75361H6ZM6 9.75361C6.79565 9.75361 7.55871 10.0697 8.12132 10.6323C8.68393 11.1949 9 11.958 9 12.7536V13.5036C9 13.9014 9.15804 14.283 9.43934 14.5643C9.72064 14.8456 10.1022 15.0036 10.5 15.0036C10.8978 15.0036 11.2794 14.8456 11.5607 14.5643C11.842 14.283 12 13.9014 12 13.5036V9.75361H14.25C14.6478 9.75361 15.0294 9.59558 15.3107 9.31427C15.592 9.03297 15.75 8.65144 15.75 8.25361L15 4.50361C14.8921 4.04351 14.6875 3.64843 14.417 3.37789C14.1464 3.10735 13.8246 2.97599 13.5 3.00361H8.25C7.65326 3.00361 7.08097 3.24066 6.65901 3.66262C6.23705 4.08458 6 4.65687 6 5.25361"
                stroke="#5F626B"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_dislike_main">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>
        }

        @if (isDislikeSelected) {
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_dislike_main2)">
              <path
                d="M9.75 15.75C10.3239 15.75 10.8761 15.5308 11.2937 15.137C11.7113 14.7433 11.9626 14.2049 11.9963 13.632L12 13.5V10.5H13.5C14.0513 10.5001 14.5835 10.2977 14.9955 9.93136C15.4075 9.56498 15.6707 9.06008 15.735 8.5125L15.7463 8.382L15.75 8.25L15.735 8.103L14.9805 4.329C14.6948 3.1095 13.854 2.232 12.873 2.244L12.75 2.25H6.75C6.5663 2.25002 6.389 2.31747 6.25172 2.43954C6.11444 2.56161 6.02674 2.72981 6.00525 2.91225L6 3L6.00075 10.152C6.00089 10.2835 6.0356 10.4127 6.10142 10.5266C6.16724 10.6404 6.26185 10.735 6.37575 10.8007C6.69557 10.9855 6.96496 11.2461 7.16013 11.5597C7.35529 11.8732 7.47022 12.23 7.49475 12.5985L7.5 12.75V13.5C7.5 14.0967 7.73705 14.669 8.15901 15.091C8.58097 15.5129 9.15326 15.75 9.75 15.75Z"
                fill="#FA0000"
              />
              <path
                d="M3.75 10.5C3.9337 10.5 4.111 10.4325 4.24828 10.3105C4.38556 10.1884 4.47326 10.0202 4.49475 9.83775L4.5 9.75V3C4.49998 2.8163 4.43253 2.639 4.31046 2.50172C4.18839 2.36444 4.02019 2.27674 3.83775 2.25525L3.75 2.25H3C2.62157 2.24988 2.25708 2.39281 1.97959 2.65012C1.7021 2.90744 1.53213 3.26013 1.50375 3.6375L1.5 3.75V9C1.49988 9.37843 1.6428 9.74292 1.90012 10.0204C2.15744 10.2979 2.51013 10.4679 2.8875 10.4962L3 10.5H3.75Z"
                fill="#FA0000"
              />
            </g>
            <defs>
              <clipPath id="clip0_dislike_main2">
                <rect
                  width="18"
                  height="18"
                  fill="white"
                  transform="matrix(1 0 0 -1 0 18)"
                />
              </clipPath>
            </defs>
          </svg>
        }
      </div>
    </div>
  </div>
}
<!-- Popup Modal -->
@if (isDislikePopupVisible) {
  <div class="popup-modal">
    <div class="popup-content">
      <div class="feedback-header">
        Tell Us More About Your Experience in {{ feedBackStage }} Stage
      </div>
      <div class="feedback-subheader">
        Describe what went well or what could be improved in this stage.
      </div>
      <div class="feedback-options">
        @for (option of feedbackOptions; track option) {
          <button
            [class.selected]="
              ComparisonNormalizer.string(selectedOption) ===
              ComparisonNormalizer.string(option)
            "
            (click)="selectFeedbackOption(option)"
          >
            {{ option }}
          </button>
        }
      </div>
      @if (ComparisonNormalizer.string(selectedOption) === "others...") {
        <textarea
          id="dislike-feedback-other"
          placeholder="What was unsatisfying about this response?"
          [(ngModel)]="dislikeFeedback"
          aria-label="Additional feedback"
        ></textarea>
      }
      <div class="popup-actions">
        <button class="mmp-btn-secondary" (click)="closeDislikePopup()">
          Cancel
        </button>
        <button class="mmp-btn-primary" (click)="submitDislikeFeedback()">
          Save
        </button>
      </div>
    </div>
  </div>
}

@if (finalFeedback) {
  <div class="popup-modal final-feedback">
    <div class="popup-content">
      <div class="feedback-header">
        <span>Share your feedback</span>
        <button
          type="button"
          class="close-icon"
          aria-label="Close"
          (click)="closeFinalFeedbackModal()"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_close_main)">
              <path
                d="M15 5L5 15"
                stroke="#030213"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5 5L15 15"
                stroke="#030213"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_close_main">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
      <div class="feedback-subheader">
        Tell us how each stage performed during this application.
      </div>
      <div class="feedback-section">
        <div class="accordion-item">
          <div class="accordion-header horizontal-line">
            Extraction
            <div class="feedback-icons horizontal-line">
              <div
                class="like"
                (click)="likeExtractionFeedback()"
                (keydown)="likeExtractionFeedback()"
              >
                @if (!isExtractionLikeSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Like</title>
                    <g clip-path="url(#clip0_dislike_extraction)">
                      <path
                        d="M5.25 8.25029V14.2503C5.25 14.4492 5.17098 14.64 5.03033 14.7806C4.88968 14.9213 4.69891 15.0003 4.5 15.0003H3C2.80109 15.0003 2.61032 14.9213 2.46967 14.7806C2.32902 14.64 2.25 14.4492 2.25 14.2503V9.00029C2.25 8.80138 2.32902 8.61062 2.46967 8.46996C2.61032 8.32931 2.80109 8.25029 3 8.25029H5.25ZM5.25 8.25029C6.04565 8.25029 6.80871 7.93422 7.37132 7.37162C7.93393 6.80901 8.25 6.04594 8.25 5.25029V4.50029C8.25 4.10247 8.40804 3.72094 8.68934 3.43964C8.97064 3.15833 9.35218 3.00029 9.75 3.00029C10.1478 3.00029 10.5294 3.15833 10.8107 3.43964C11.092 3.72094 11.25 4.10247 11.25 4.50029V8.25029H13.5C13.8978 8.25029 14.2794 8.40833 14.5607 8.68964C14.842 8.97094 15 9.35247 15 9.75029L14.25 13.5003C14.1421 13.9604 13.9375 14.3555 13.667 14.626C13.3964 14.8966 13.0746 15.0279 12.75 15.0003H7.5C6.90326 15.0003 6.33097 14.7632 5.90901 14.3413C5.48705 13.9193 5.25 13.347 5.25 12.7503"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_extraction">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 18)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }
                @if (isExtractionLikeSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_like_extraction)">
                      <path
                        d="M9.75 2.25C10.3239 2.24997 10.8761 2.46924 11.2937 2.86296C11.7113 3.25668 11.9626 3.79508 11.9963 4.368L12 4.5V7.5H13.5C14.0513 7.49991 14.5835 7.70226 14.9955 8.06864C15.4075 8.43502 15.6707 8.93992 15.735 9.4875L15.7463 9.618L15.75 9.75L15.735 9.897L14.9805 13.671C14.6948 14.8905 13.854 15.768 12.873 15.756L12.75 15.75H6.75C6.5663 15.75 6.389 15.6825 6.25172 15.5605C6.11444 15.4384 6.02674 15.2702 6.00525 15.0878L6 15L6.00075 7.848C6.00089 7.71648 6.0356 7.5873 6.10142 7.47344C6.16724 7.35957 6.26185 7.26501 6.37575 7.19925C6.69557 7.01454 6.96496 6.7539 7.16013 6.44035C7.35529 6.1268 7.47022 5.77001 7.49475 5.4015L7.5 5.25V4.5C7.5 3.90326 7.73705 3.33097 8.15901 2.90901C8.58097 2.48705 9.15326 2.25 9.75 2.25Z"
                        fill="#088E6D"
                      />
                      <path
                        d="M3.75 7.5C3.9337 7.50002 4.111 7.56747 4.24828 7.68954C4.38556 7.81161 4.47326 7.97981 4.49475 8.16225L4.5 8.25V15C4.49998 15.1837 4.43253 15.361 4.31046 15.4983C4.18839 15.6356 4.02019 15.7233 3.83775 15.7448L3.75 15.75H3C2.62157 15.7501 2.25708 15.6072 1.97959 15.3499C1.7021 15.0926 1.53213 14.7399 1.50375 14.3625L1.5 14.25V9C1.49988 8.62157 1.6428 8.25708 1.90012 7.97959C2.15744 7.7021 2.51013 7.53213 2.8875 7.50375L3 7.5H3.75Z"
                        fill="#088E6D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_like_extraction">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
              </div>
              <div
                class="dislike"
                (click)="toggleSection('extraction')"
                (keydown)="toggleSection('extraction')"
              >
                @if (!isDislikeExtractionSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_dislike_extraction2)">
                      <path
                        d="M6 9.75361V3.75361C6 3.5547 5.92098 3.36393 5.78033 3.22328C5.63968 3.08263 5.44891 3.00361 5.25 3.00361H3.75C3.55109 3.00361 3.36032 3.08263 3.21967 3.22328C3.07902 3.36393 3 3.5547 3 3.75361V9.00361C3 9.20252 3.07902 9.39329 3.21967 9.53394C3.36032 9.67459 3.55109 9.75361 3.75 9.75361H6ZM6 9.75361C6.79565 9.75361 7.55871 10.0697 8.12132 10.6323C8.68393 11.1949 9 11.958 9 12.7536V13.5036C9 13.9014 9.15804 14.283 9.43934 14.5643C9.72064 14.8456 10.1022 15.0036 10.5 15.0036C10.8978 15.0036 11.2794 14.8456 11.5607 14.5643C11.842 14.283 12 13.9014 12 13.5036V9.75361H14.25C14.6478 9.75361 15.0294 9.59558 15.3107 9.31427C15.592 9.03297 15.75 8.65144 15.75 8.25361L15 4.50361C14.8921 4.04351 14.6875 3.64843 14.417 3.37789C14.1464 3.10735 13.8246 2.97599 13.5 3.00361H8.25C7.65326 3.00361 7.08097 3.24066 6.65901 3.66262C6.23705 4.08458 6 4.65687 6 5.25361"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_extraction2">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                @if (isDislikeExtractionSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_dislike_extraction3)">
                      <path
                        d="M9.75 15.75C10.3239 15.75 10.8761 15.5308 11.2937 15.137C11.7113 14.7433 11.9626 14.2049 11.9963 13.632L12 13.5V10.5H13.5C14.0513 10.5001 14.5835 10.2977 14.9955 9.93136C15.4075 9.56498 15.6707 9.06008 15.735 8.5125L15.7463 8.382L15.75 8.25L15.735 8.103L14.9805 4.329C14.6948 3.1095 13.854 2.232 12.873 2.244L12.75 2.25H6.75C6.5663 2.25002 6.389 2.31747 6.25172 2.43954C6.11444 2.56161 6.02674 2.72981 6.00525 2.91225L6 3L6.00075 10.152C6.00089 10.2835 6.0356 10.4127 6.10142 10.5266C6.16724 10.6404 6.26185 10.735 6.37575 10.8007C6.69557 10.9855 6.96496 11.2461 7.16013 11.5597C7.35529 11.8732 7.47022 12.23 7.49475 12.5985L7.5 12.75V13.5C7.5 14.0967 7.73705 14.669 8.15901 15.091C8.58097 15.5129 9.15326 15.75 9.75 15.75Z"
                        fill="#FA0000"
                      />
                      <path
                        d="M3.75 10.5C3.9337 10.5 4.111 10.4325 4.24828 10.3105C4.38556 10.1884 4.47326 10.0202 4.49475 9.83775L4.5 9.75V3C4.49998 2.8163 4.43253 2.639 4.31046 2.50172C4.18839 2.36444 4.02019 2.27674 3.83775 2.25525L3.75 2.25H3C2.62157 2.24988 2.25708 2.39281 1.97959 2.65012C1.7021 2.90744 1.53213 3.26013 1.50375 3.6375L1.5 3.75V9C1.49988 9.37843 1.6428 9.74292 1.90012 10.0204C2.15744 10.2979 2.51013 10.4679 2.8875 10.4962L3 10.5H3.75Z"
                        fill="#FA0000"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_extraction3">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 18)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }
              </div>
            </div>
          </div>
          @if (isExtractionVisible) {
            <div class="accordion-content">
              <div class="feedback-options">
                @for (option of extractionFeedbackOptions; track option) {
                  <button
                    [class.selected]="
                      ComparisonNormalizer.string(selectedExtractionOption) ===
                      ComparisonNormalizer.string(option)
                    "
                    (click)="selectExtractionFeedbackOption(option)"
                  >
                    {{ option }}
                  </button>
                }
              </div>
              @if (
                ComparisonNormalizer.string(selectedExtractionOption) ===
                "others..."
              ) {
                <textarea
                  id="dislike-extraction-feedback-other"
                  placeholder="What was unsatisfying about this response?"
                  [(ngModel)]="dislikeExtractionFeedback"
                  aria-label="Additional feedback"
                ></textarea>
              }
            </div>
          }
        </div>
        <!-- Accordion for Evaluation -->
        <div class="accordion-item">
          <div class="accordion-header horizontal-line">
            Evaluation
            <div class="feedback-icons horizontal-line">
              <div
                class="like"
                (click)="likeEvaluationFeedback()"
                (keydown)="likeEvaluationFeedback()"
              >
                @if (!isLikeEvaluationSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Like</title>
                    <g clip-path="url(#clip0_dislike_evaluation)">
                      <path
                        d="M5.25 8.25029V14.2503C5.25 14.4492 5.17098 14.64 5.03033 14.7806C4.88968 14.9213 4.69891 15.0003 4.5 15.0003H3C2.80109 15.0003 2.61032 14.9213 2.46967 14.7806C2.32902 14.64 2.25 14.4492 2.25 14.2503V9.00029C2.25 8.80138 2.32902 8.61062 2.46967 8.46996C2.61032 8.32931 2.80109 8.25029 3 8.25029H5.25ZM5.25 8.25029C6.04565 8.25029 6.80871 7.93422 7.37132 7.37162C7.93393 6.80901 8.25 6.04594 8.25 5.25029V4.50029C8.25 4.10247 8.40804 3.72094 8.68934 3.43964C8.97064 3.15833 9.35218 3.00029 9.75 3.00029C10.1478 3.00029 10.5294 3.15833 10.8107 3.43964C11.092 3.72094 11.25 4.10247 11.25 4.50029V8.25029H13.5C13.8978 8.25029 14.2794 8.40833 14.5607 8.68964C14.842 8.97094 15 9.35247 15 9.75029L14.25 13.5003C14.1421 13.9604 13.9375 14.3555 13.667 14.626C13.3964 14.8966 13.0746 15.0279 12.75 15.0003H7.5C6.90326 15.0003 6.33097 14.7632 5.90901 14.3413C5.48705 13.9193 5.25 13.347 5.25 12.7503"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_evaluation">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 18)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }
                @if (isLikeEvaluationSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_like_evaluation)">
                      <path
                        d="M9.75 2.25C10.3239 2.24997 10.8761 2.46924 11.2937 2.86296C11.7113 3.25668 11.9626 3.79508 11.9963 4.368L12 4.5V7.5H13.5C14.0513 7.49991 14.5835 7.70226 14.9955 8.06864C15.4075 8.43502 15.6707 8.93992 15.735 9.4875L15.7463 9.618L15.75 9.75L15.735 9.897L14.9805 13.671C14.6948 14.8905 13.854 15.768 12.873 15.756L12.75 15.75H6.75C6.5663 15.75 6.389 15.6825 6.25172 15.5605C6.11444 15.4384 6.02674 15.2702 6.00525 15.0878L6 15L6.00075 7.848C6.00089 7.71648 6.0356 7.5873 6.10142 7.47344C6.16724 7.35957 6.26185 7.26501 6.37575 7.19925C6.69557 7.01454 6.96496 6.7539 7.16013 6.44035C7.35529 6.1268 7.47022 5.77001 7.49475 5.4015L7.5 5.25V4.5C7.5 3.90326 7.73705 3.33097 8.15901 2.90901C8.58097 2.48705 9.15326 2.25 9.75 2.25Z"
                        fill="#088E6D"
                      />
                      <path
                        d="M3.75 7.5C3.9337 7.50002 4.111 7.56747 4.24828 7.68954C4.38556 7.81161 4.47326 7.97981 4.49475 8.16225L4.5 8.25V15C4.49998 15.1837 4.43253 15.361 4.31046 15.4983C4.18839 15.6356 4.02019 15.7233 3.83775 15.7448L3.75 15.75H3C2.62157 15.7501 2.25708 15.6072 1.97959 15.3499C1.7021 15.0926 1.53213 14.7399 1.50375 14.3625L1.5 14.25V9C1.49988 8.62157 1.6428 8.25708 1.90012 7.97959C2.15744 7.7021 2.51013 7.53213 2.8875 7.50375L3 7.5H3.75Z"
                        fill="#088E6D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_like_evaluation">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
              </div>
              <div
                class="dislike"
                (click)="toggleSection('evaluation')"
                (keydown)="toggleSection('evaluation')"
              >
                @if (!isDislikeEvaluationSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_dislike_evaluation2)">
                      <path
                        d="M6 9.75361V3.75361C6 3.5547 5.92098 3.36393 5.78033 3.22328C5.63968 3.08263 5.44891 3.00361 5.25 3.00361H3.75C3.55109 3.00361 3.36032 3.08263 3.21967 3.22328C3.07902 3.36393 3 3.5547 3 3.75361V9.00361C3 9.20252 3.07902 9.39329 3.21967 9.53394C3.36032 9.67459 3.55109 9.75361 3.75 9.75361H6ZM6 9.75361C6.79565 9.75361 7.55871 10.0697 8.12132 10.6323C8.68393 11.1949 9 11.958 9 12.7536V13.5036C9 13.9014 9.15804 14.283 9.43934 14.5643C9.72064 14.8456 10.1022 15.0036 10.5 15.0036C10.8978 15.0036 11.2794 14.8456 11.5607 14.5643C11.842 14.283 12 13.9014 12 13.5036V9.75361H14.25C14.6478 9.75361 15.0294 9.59558 15.3107 9.31427C15.592 9.03297 15.75 8.65144 15.75 8.25361L15 4.50361C14.8921 4.04351 14.6875 3.64843 14.417 3.37789C14.1464 3.10735 13.8246 2.97599 13.5 3.00361H8.25C7.65326 3.00361 7.08097 3.24066 6.65901 3.66262C6.23705 4.08458 6 4.65687 6 5.25361"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_evaluation2">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                @if (isDislikeEvaluationSelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_dislike_evaluation3)">
                      <path
                        d="M9.75 15.75C10.3239 15.75 10.8761 15.5308 11.2937 15.137C11.7113 14.7433 11.9626 14.2049 11.9963 13.632L12 13.5V10.5H13.5C14.0513 10.5001 14.5835 10.2977 14.9955 9.93136C15.4075 9.56498 15.6707 9.06008 15.735 8.5125L15.7463 8.382L15.75 8.25L15.735 8.103L14.9805 4.329C14.6948 3.1095 13.854 2.232 12.873 2.244L12.75 2.25H6.75C6.5663 2.25002 6.389 2.31747 6.25172 2.43954C6.11444 2.56161 6.02674 2.72981 6.00525 2.91225L6 3L6.00075 10.152C6.00089 10.2835 6.0356 10.4127 6.10142 10.5266C6.16724 10.6404 6.26185 10.735 6.37575 10.8007C6.69557 10.9855 6.96496 11.2461 7.16013 11.5597C7.35529 11.8732 7.47022 12.23 7.49475 12.5985L7.5 12.75V13.5C7.5 14.0967 7.73705 14.669 8.15901 15.091C8.58097 15.5129 9.15326 15.75 9.75 15.75Z"
                        fill="#FA0000"
                      />
                      <path
                        d="M3.75 10.5C3.9337 10.5 4.111 10.4325 4.24828 10.3105C4.38556 10.1884 4.47326 10.0202 4.49475 9.83775L4.5 9.75V3C4.49998 2.8163 4.43253 2.639 4.31046 2.50172C4.18839 2.36444 4.02019 2.27674 3.83775 2.25525L3.75 2.25H3C2.62157 2.24988 2.25708 2.39281 1.97959 2.65012C1.7021 2.90744 1.53213 3.26013 1.50375 3.6375L1.5 3.75V9C1.49988 9.37843 1.6428 9.74292 1.90012 10.0204C2.15744 10.2979 2.51013 10.4679 2.8875 10.4962L3 10.5H3.75Z"
                        fill="#FA0000"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_evaluation3">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 18)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }
              </div>
            </div>
          </div>
          @if (isEvaluationVisible) {
            <div class="accordion-content">
              <div class="feedback-options">
                @for (option of evaluationFeedbackOptions; track option) {
                  <button
                    [class.selected]="
                      ComparisonNormalizer.string(selectedEvaluationOption) ===
                      ComparisonNormalizer.string(option)
                    "
                    (click)="selectEvaluationFeedbackOption(option)"
                  >
                    {{ option }}
                  </button>
                }
              </div>
              @if (
                ComparisonNormalizer.string(selectedEvaluationOption) ===
                "others..."
              ) {
                <textarea
                  id="dislike-evaluation-feedback-other"
                  placeholder="What was unsatisfying about this response?"
                  [(ngModel)]="dislikeEvaluationFeedback"
                  aria-label="Additional feedback"
                ></textarea>
              }
            </div>
          }
        </div>
        <!-- Accordion for Equivalency -->
        <div class="accordion-item">
          <div class="accordion-header horizontal-line">
            Equivalency
            <div class="feedback-icons horizontal-line">
              <div
                class="like"
                (click)="likeEquivalencyFeedback()"
                (keydown)="likeEquivalencyFeedback()"
              >
                @if (!isLikeEquivalencySelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title>Like</title>
                    <g clip-path="url(#clip0_dislike_equivalency)">
                      <path
                        d="M5.25 8.25029V14.2503C5.25 14.4492 5.17098 14.64 5.03033 14.7806C4.88968 14.9213 4.69891 15.0003 4.5 15.0003H3C2.80109 15.0003 2.61032 14.9213 2.46967 14.7806C2.32902 14.64 2.25 14.4492 2.25 14.2503V9.00029C2.25 8.80138 2.32902 8.61062 2.46967 8.46996C2.61032 8.32931 2.80109 8.25029 3 8.25029H5.25ZM5.25 8.25029C6.04565 8.25029 6.80871 7.93422 7.37132 7.37162C7.93393 6.80901 8.25 6.04594 8.25 5.25029V4.50029C8.25 4.10247 8.40804 3.72094 8.68934 3.43964C8.97064 3.15833 9.35218 3.00029 9.75 3.00029C10.1478 3.00029 10.5294 3.15833 10.8107 3.43964C11.092 3.72094 11.25 4.10247 11.25 4.50029V8.25029H13.5C13.8978 8.25029 14.2794 8.40833 14.5607 8.68964C14.842 8.97094 15 9.35247 15 9.75029L14.25 13.5003C14.1421 13.9604 13.9375 14.3555 13.667 14.626C13.3964 14.8966 13.0746 15.0279 12.75 15.0003H7.5C6.90326 15.0003 6.33097 14.7632 5.90901 14.3413C5.48705 13.9193 5.25 13.347 5.25 12.7503"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_equivalency">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 18)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }
                @if (isLikeEquivalencySelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_like_equivalency)">
                      <path
                        d="M9.75 2.25C10.3239 2.24997 10.8761 2.46924 11.2937 2.86296C11.7113 3.25668 11.9626 3.79508 11.9963 4.368L12 4.5V7.5H13.5C14.0513 7.49991 14.5835 7.70226 14.9955 8.06864C15.4075 8.43502 15.6707 8.93992 15.735 9.4875L15.7463 9.618L15.75 9.75L15.735 9.897L14.9805 13.671C14.6948 14.8905 13.854 15.768 12.873 15.756L12.75 15.75H6.75C6.5663 15.75 6.389 15.6825 6.25172 15.5605C6.11444 15.4384 6.02674 15.2702 6.00525 15.0878L6 15L6.00075 7.848C6.00089 7.71648 6.0356 7.5873 6.10142 7.47344C6.16724 7.35957 6.26185 7.26501 6.37575 7.19925C6.69557 7.01454 6.96496 6.7539 7.16013 6.44035C7.35529 6.1268 7.47022 5.77001 7.49475 5.4015L7.5 5.25V4.5C7.5 3.90326 7.73705 3.33097 8.15901 2.90901C8.58097 2.48705 9.15326 2.25 9.75 2.25Z"
                        fill="#088E6D"
                      />
                      <path
                        d="M3.75 7.5C3.9337 7.50002 4.111 7.56747 4.24828 7.68954C4.38556 7.81161 4.47326 7.97981 4.49475 8.16225L4.5 8.25V15C4.49998 15.1837 4.43253 15.361 4.31046 15.4983C4.18839 15.6356 4.02019 15.7233 3.83775 15.7448L3.75 15.75H3C2.62157 15.7501 2.25708 15.6072 1.97959 15.3499C1.7021 15.0926 1.53213 14.7399 1.50375 14.3625L1.5 14.25V9C1.49988 8.62157 1.6428 8.25708 1.90012 7.97959C2.15744 7.7021 2.51013 7.53213 2.8875 7.50375L3 7.5H3.75Z"
                        fill="#088E6D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_like_equivalency">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
              </div>
              <div
                class="dislike"
                (click)="toggleSection('equivalency')"
                (keydown)="toggleSection('equivalency')"
              >
                @if (!isDislikeEquivalencySelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_dislike_equivalency2)">
                      <path
                        d="M6 9.75361V3.75361C6 3.5547 5.92098 3.36393 5.78033 3.22328C5.63968 3.08263 5.44891 3.00361 5.25 3.00361H3.75C3.55109 3.00361 3.36032 3.08263 3.21967 3.22328C3.07902 3.36393 3 3.5547 3 3.75361V9.00361C3 9.20252 3.07902 9.39329 3.21967 9.53394C3.36032 9.67459 3.55109 9.75361 3.75 9.75361H6ZM6 9.75361C6.79565 9.75361 7.55871 10.0697 8.12132 10.6323C8.68393 11.1949 9 11.958 9 12.7536V13.5036C9 13.9014 9.15804 14.283 9.43934 14.5643C9.72064 14.8456 10.1022 15.0036 10.5 15.0036C10.8978 15.0036 11.2794 14.8456 11.5607 14.5643C11.842 14.283 12 13.9014 12 13.5036V9.75361H14.25C14.6478 9.75361 15.0294 9.59558 15.3107 9.31427C15.592 9.03297 15.75 8.65144 15.75 8.25361L15 4.50361C14.8921 4.04351 14.6875 3.64843 14.417 3.37789C14.1464 3.10735 13.8246 2.97599 13.5 3.00361H8.25C7.65326 3.00361 7.08097 3.24066 6.65901 3.66262C6.23705 4.08458 6 4.65687 6 5.25361"
                        stroke="#5F626B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_dislike_equivalency2">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                }
                @if (isDislikeEquivalencySelected) {
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_like_equivalency3)">
                      <path
                        d="M9.75 15.75C10.3239 15.75 10.8761 15.5308 11.2937 15.137C11.7113 14.7433 11.9626 14.2049 11.9963 13.632L12 13.5V10.5H13.5C14.0513 10.5001 14.5835 10.2977 14.9955 9.93136C15.4075 9.56498 15.6707 9.06008 15.735 8.5125L15.7463 8.382L15.75 8.25L15.735 8.103L14.9805 4.329C14.6948 3.1095 13.854 2.232 12.873 2.244L12.75 2.25H6.75C6.5663 2.25002 6.389 2.31747 6.25172 2.43954C6.11444 2.56161 6.02674 2.72981 6.00525 2.91225L6 3L6.00075 10.152C6.00089 10.2835 6.0356 10.4127 6.10142 10.5266C6.16724 10.6404 6.26185 10.735 6.37575 10.8007C6.69557 10.9855 6.96496 11.2461 7.16013 11.5597C7.35529 11.8732 7.47022 12.23 7.49475 12.5985L7.5 12.75V13.5C7.5 14.0967 7.73705 14.669 8.15901 15.091C8.58097 15.5129 9.15326 15.75 9.75 15.75Z"
                        fill="#FA0000"
                      />
                      <path
                        d="M3.75 10.5C3.9337 10.5 4.111 10.4325 4.24828 10.3105C4.38556 10.1884 4.47326 10.0202 4.49475 9.83775L4.5 9.75V3C4.49998 2.8163 4.43253 2.639 4.31046 2.50172C4.18839 2.36444 4.02019 2.27674 3.83775 2.25525L3.75 2.25H3C2.62157 2.24988 2.25708 2.39281 1.97959 2.65012C1.7021 2.90744 1.53213 3.26013 1.50375 3.6375L1.5 3.75V9C1.49988 9.37843 1.6428 9.74292 1.90012 10.0204C2.15744 10.2979 2.51013 10.4679 2.8875 10.4962L3 10.5H3.75Z"
                        fill="#FA0000"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_like_equivalency3">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="matrix(1 0 0 -1 0 18)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }
              </div>
            </div>
          </div>
          @if (isEquivalencyVisible) {
            <div class="accordion-content">
              <div class="feedback-options">
                @for (option of equivalencyFeedbackOptions; track option) {
                  <button
                    [class.selected]="
                      ComparisonNormalizer.string(selectedEquivalencyOption) ===
                      ComparisonNormalizer.string(option)
                    "
                    (click)="selectEquivalencyFeedbackOption(option)"
                  >
                    {{ option }}
                  </button>
                }
              </div>
              @if (
                ComparisonNormalizer.string(selectedEquivalencyOption) ===
                "others..."
              ) {
                <textarea
                  id="dislike-equivalency-feedback-other"
                  placeholder="What was unsatisfying about this response?"
                  [(ngModel)]="dislikeEquivalencyFeedback"
                  aria-label="Additional feedback"
                ></textarea>
              }
            </div>
          }
        </div>
      </div>
      <div class="popup-actions">
        <button class="mmp-btn-secondary" (click)="closeFinalFeedbackPopup()">
          Skip and Complete
        </button>
        <button class="mmp-btn-primary" (click)="submitFinalFeedback()">
          Submit and Complete
        </button>
      </div>
    </div>
  </div>
}
